export default __webpack_public_path__ + "static/media/completed_male@3x.6b82d240.png";